import { Injectable } from '@angular/core';
import { AccessibilityFastTrackRepoService } from '@client/app/services/api/accessibility/accessibility-fast-track-repo/accessibility-fast-track-repo.service';
import { AccessibilityChecksRepoService } from '@client/app/services/api/accessibility/accessibility-checks-repo/accessibility-checks-repo.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';

@Injectable({
    providedIn: 'root',
})
export class AccessibilityService {

    constructor (
        private accessibilityFastTrackRepo: AccessibilityFastTrackRepoService,
        private accessibilityChecksRepoService: AccessibilityChecksRepoService,
        private monEventService: MonEventService,
    ) { }

    /**
     * @desc Update Fasttrack check
     * @param {number} id The id of the issue
     * @param {object} content Check object
     * @param {string} type The type of update
     * @returns {Promise}
     */
    fastTrackUpdateCheck (id: number, content: any, type: string): Promise<any> {
        return this.accessibilityFastTrackRepo.updateCheck(id, content).then((data) => {
            this.monEventService.run('fasttrack' + type, content.id);
            return data;
        }).catch(() => {
            // Handle error silently like original angular.noop
            return undefined;
        });
    }

    /**
     * @desc Update Accessibility check
     * @param {number} checkId The check id to update
     * @param {object} payload The modified check data
     * @returns {Promise}
     */
    updateCheck (checkId: number, payload: any): Promise<any> {
        return this.accessibilityChecksRepoService.update(checkId, payload);
    }

    /**
     * @desc Update Fasttrack close caption
     * @param {number} accId The id of the accessibility
     * @param {object} data Check object
     * @param {any} params Query parameters
     * @param {any} config HTTP configuration
     * @returns {Promise}
     */
    fastTrackCloseCaption (accId: number, data: any, params?: any, config?: any): Promise<any> {
        return this.accessibilityFastTrackRepo.closeCaption(accId, data, params, config);
    }

    /**
     * @desc Undo Accessibility check
     * @param {number} domainId The id of the domain
     * @param {number} accessibilitySourceCodeId The id of the accessibility source code
     * @param {number} checkId Check id
     * @param {any} params Query parameters
     * @returns {Promise}
     */
    undoAccessibilityCheck (domainId: number, accessibilitySourceCodeId: number, checkId: number, params?: any): Promise<any> {
        return this.accessibilityFastTrackRepo.undoAccessibilityCheck(domainId, accessibilitySourceCodeId, checkId, params);
    }
}
